<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-14 16:48:47
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-26 10:15:43
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\selectionDecoration\list\components\tableCells\showcaseSkipIpCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="yx-color-pure-1">
		<div class="yx-color-pure-1 font-h4-regular flex flex-align-center" v-for="(item, index) in locationList" :key="index">
			<el-tooltip placement="top" :content="item.linkName + item.linkTypeDesc" v-ak-tooltip-auto-show>
				<p class="yx-color-pure-1 font-h4-regular line-ellipsis-1" style="width: 100%;" v-if="row.type === 1">{{
					item.linkName + item.linkTypeDesc
				}}</p>
				<p class="line-ellipsis-1" style="width: calc(100% -20px);" v-else>
					<span>位置{{ index + 1 }}：</span>
					<span> {{ item.linkName + item.linkTypeDesc }}</span>
				</p>
			</el-tooltip>
			<div class="ml-4 cursor-pointer" @click="open(item)">
				<i class="i-scan-qrcode"></i>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	computed: {
		locationList({ row }) {
			const { locationList = [] } = row;
			if (row.type === 1) {
				return locationList || [];
			} else {
				const list = JSON.parse(JSON.stringify(locationList));
				list.splice(0, 1);
				return list;
			}
		},
	},
	data() {
		return {};
	},
	methods: {
		open({ link, linkType }) {
			const { platformId } = this.row;
			this.row.operations.openPreview({ preview: 'preview_goods', platformId, link, linkType });
		},
	},
};
</script>
<style lang="less" scoped></style>
